var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/minus.d325c5dc.png","uri@2x": __webpack_public_path__ + "static/media/minus.de323518.png","uri@3x": __webpack_public_path__ + "static/media/minus.9b9dee94.png",
    width: 18,
    height: 8
});